import { render, staticRenderFns } from "./ComfortSleepModal.vue?vue&type=template&id=200e0e21"
import script from "./ComfortSleepModal.vue?vue&type=script&lang=js"
export * from "./ComfortSleepModal.vue?vue&type=script&lang=js"
import style0 from "./ComfortSleepModal.vue?vue&type=style&index=0&id=200e0e21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangeSlider: require('/app/components/RangeSlider.vue').default})
